import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {Form, ErrorContainer} from 'form';

import Checkbox from './../form/Checkbox';

import '../../sass/modals/modalDisclaimer.scss';

import LangButton from 'components/modals/LangButton';
import {Link} from 'components/ReactRouterDomLocalized';

import {t, dt, getLocale} from 'l10n';
import {getCookie} from "../../utils/cookie";
import {connect} from "react-redux";
import {frontloadConnect} from "react-frontload";
import {withRouter} from "react-router";
import queryString from "query-string";

class ModalDisclaimer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: true
        };

        this.onAcceptClick = this.onAcceptClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
    }


    componentDidMount() {
        this.updateMenuStyles();
        this.removeModalOpenClass();

        const shouldObserve = this.checkAndApplyBlur();

        if (shouldObserve) {
            this.observer = new MutationObserver(this.checkAndApplyBlur);
            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            this.cookieCheckInterval = setInterval(() => {
                if (!getCookie('VISITED')) {
                    this.checkAndApplyBlur();
                    clearInterval(this.cookieCheckInterval);
                }
            }, 1000);
        }
    }

    componentDidUpdate() {
        this.removeModalOpenClass();
    }

    componentWillUnmount() {
        this.restoreMenuStyles();
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.cookieCheckInterval) {
            clearInterval(this.cookieCheckInterval);
        }
    }


    observer = null;
    cookieCheckInterval = null;

    checkAndApplyBlur = () => {
        const isVerified = getCookie('VISITED');

        const linksWithBgImage = document.querySelectorAll('a[style*="background-image"]');
        linksWithBgImage.forEach(link => {
            if (!link.closest('#menu_container') && !link.closest('iframe')) {
                link.style.filter = isVerified ? '' : 'blur(10px)';
            }
        })

        document.querySelectorAll('img').forEach((img) => {
            img.style.filter = isVerified ? '' : 'blur(10px)';
        });

        return !isVerified;
    };


    removeModalOpenClass = () => {
        document.body.style.overflowY = 'auto'
        if (document.body.classList.contains('modal-open')) {
            document.body.classList.remove('modal-open');
        }
    }

    updateMenuStyles = () => {
        const menu = document.querySelector('.icon-menu');
        if (menu) {
            this.originalStyle = {
                zIndex: menu.style.zIndex,
                boxShadow: menu.style.boxShadow
            };

            menu.style.zIndex = '1061';
            menu.style.boxShadow = '0px 0px 20px 7px rgba(255, 255, 255, 0.5)';
        }
    };

    restoreMenuStyles = () => {
        const menu = document.querySelector('.icon-menu');
        if (menu && this.originalStyle) {
            menu.style.zIndex = this.originalStyle.zIndex || '';
            menu.style.boxShadow = this.originalStyle.boxShadow || '';
        }
    };

    toggleCheck() {
        this.setState({checked: !this.state.checked});
    }

    onConfirmClick() {
        this.props.setDisclaimer();

        if (typeof window !== 'undefined') {
                document.body.style.paddingRight = '30px'
                document.querySelector('.modalDisclaimer').style.paddingRight = '30px'

            try {
                //@ts-ignore
                window.ageverif.start({ closable: true });

            } catch (e) {
                this.props.setDisclaimer(true)
                console.error('AgeVerify initialization error:', e);
            }
                setTimeout(() => {
                    document.body.style.paddingRight = '15px'
                    document.querySelector('.modalDisclaimer').style.paddingRight = '15px'
                    this.removeModalOpenClass();
                }, 1)
        }
    }

    onAcceptClick() {

        const {history, location} = this.props;
        history.push(
            location.pathname + '?' + 'ageverif'
        )
        // this.props.setDisclaimer();
        //
        // if (typeof window !== 'undefined') {
        //         document.body.style.paddingRight = '30px'
        //         document.querySelector('.modalDisclaimer').style.paddingRight = '30px'
        //
        //     try {
        //         //@ts-ignore
        //         window.ageverif.start();
        //
        //     } catch (e) {
        //         this.props.setDisclaimer(true)
        //         console.error('AgeVerify initialization error:', e);
        //     }
        //         setTimeout(() => {
        //             document.body.style.paddingRight = '15px'
        //             document.querySelector('.modalDisclaimer').style.paddingRight = '15px'
        //             this.removeModalOpenClass();
        //         }, 1)
        // }
    }

    render() {
        let {checked} = this.state;

        let {show} = this.props;

        let disclaimerText;
        if (getLocale() == 'fr') {
            disclaimerText = <DisclaimerTextFr/>;
        } else disclaimerText = <DisclaimerTextEn/>;

        let {location} = this.props;

        let {history} = this.props;

        if (
            typeof window !== 'undefined' &&
            window.ageverif &&
            window.ageverif.destroy &&
            location.pathname.includes('/contact'))
        {
            window.ageverif.destroy();
            return null;
        }

        return (
            <div>
                <Modal className="modalDisclaimer" show={show}>
                    <Modal.Body>
                        <header className="header-modal-disclaimer">
                            <div />
                            <div className="language-menu-disclaimer">
                                <LangButton className="item-language-menu-disclaimer" locale="fr">Fr</LangButton>
                                <LangButton className="item-language-menu-disclaimer" locale="en">En</LangButton>
                            </div>

                        </header>
                        <p className="title-modal-disclaimer">{dt('disclaimer', 'BobTV the adult webcam chat since 2007')}</p>

                        {disclaimerText}
                        <footer className="footer-modal-disclaimer">
                            <div className="buttons-modal-disclaimer">
                                <button className="enter-button-modal-disclaimer"
                                        onClick={this.onAcceptClick}>{dt('disclaimer', 'Accept and connect')}</button>
                                <button className="exit-button-modal-disclaimer"
                                        onClick={this.onConfirmClick}>{dt('disclaimer', 'Confirm my majority')}</button>

                            </div>
                        </footer>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

function DisclaimerTextEn() {
    return (
        <section className="content-modal-disclaimer">
            <p>This website is reserved for a major and warned public.</p>
            <p>It contains texts, pornographic photos and videos prohibited to minors and which may be offensive to some sensibilities.</p>
            <p>It is strongly discouraged to sensitive, fragile and impressionable people to access this site; minors mustn’t have access under any circumstances.</p>
            <p>I validate the data contained in the paragraphs below after having read them carefully and thus express my full and complete agreement, certifying that I meet all the conditions contained therein, confirming my majority.</p>
            <p className="title-content-modal-disclaimer">I certify to</p>
            <p>- Be major according to the Act of my country, and to the French law,</p>
            <p>- That the laws of my state or my country authorize me to access this site and that bobtv.fr has the right to provide me with such data,</p>
            <p>- Being informed of pornographic character of content on the server,</p>
            <p className="title-content-modal-disclaimer">I declare and acknowledge explicitly</p>
            <p>- Not to be shocked by any type of sexuality, any text, any pornographic pictures or video, and I prohibit myself to prosecute the authors of bobtv.fr due to the data on this site or its consequences;</p>
            <p>- To consult this server only for personal needs and without any involvement of a private company, a government agency, or any other public or private entity;</p>
            <p className="title-content-modal-disclaimer">I pledge on my honor</p>
            <p>- never announce the existence of the server to minors,</p>
            <p>- never allow minors to access this server and use all conducive means to prevent access this server by minors,</p>
            <p>- never broadcast all or a part of the content published on this server to minors,</p>
            <p>- to assume my responsibility in case that a minor would have access to the server because of my negligence or my recklessness (lack of protection of my computer, no censorship software, loss or disclosure of the password security ), without recourse against bobtv.fr,</p>
            <p>- to fully assume all the consequences of all kinds of declarations at all or partyally inaccurate, without recourse against its authors and bobtv.fr.</p>
            <br/>
        </section>
    )
}

function DisclaimerTextFr() {
    return (
        <section className="content-modal-disclaimer">
            <p>Ce site Internet est réservé à un public majeur et averti.</p>
            <p>Il contient des textes, des photos et des vidéos pornographiques interdits aux mineurs, qui peuvent être choquants pour certaines sensibilités.</p>
            <p>Il est vivement déconseillé aux personnes sensibles, fragiles et impressionnables d’accéder à ce site ; les mineurs ne doivent en aucun cas y accéder.</p>
            <p>Je valide les données contenues dans les paragraphes ci-dessous après les avoir lues attentivement et manifeste ainsi mon accord plein et entier, en certifiant remplir toutes les conditions qui y sont contenues, en confirmant ma majorité.</p>
            <p className="title-content-modal-disclaimer">Je certifie sur l’honneur</p>
            <p>- Etre majeur selon la Loi en vigueur dans mon pays et selon la Loi française,</p>
            <p>- Que les Lois de mon état ou de mon pays m’autorisent à accéder à ce site et que bobtv.fr a le droit de me transmettre de telles données,</p>
            <p>- Etre informé du caractère pornographique du serveur auquel j’accède,</p>
            <p className="title-content-modal-disclaimer">Je déclare et reconnais expressément</p>
            <p>- N’être choqué par aucun type de sexualité et par aucun texte, ni aucune image ou vidéo à caractère pornographique, et je m’interdis expressément de poursuivre les auteurs de bobtv.fr à raison des données diffusées sur ce site ou de leurs conséquences ;</p>
            <p>- Consulter ce serveur à titre strictement personnel, et sans aucune implication, de quelque manière que ce soit, d’une société privée, d’un organisme public, ou de toute autre entité publique ou privée ;</p>
            <p className="title-content-modal-disclaimer">Je m’engage sur l’honneur</p>
            <p>- A ne jamais faire état de l’existence de ce serveur auprès de tiers et de mineurs,</p>
            <p>- A ne jamais permettre à des mineurs d’accéder à ce serveur et à mettre en œuvre tous moyens de nature à permettre d’empêcher l’accès de tout mineur à ce serveur,</p>
            <p>- A ne jamais diffuser tout ou partie du contenu édité sur ce serveur à des mineurs pour quelque raison que ce soit,</p>
            <p>- A assumer ma responsabilité dans l’hypothèse où un mineur aurait eu accès à ce serveur à raison de ma négligence ou de mon imprudence (absence de protection de mon ordinateur, absence de logiciel de censure, divulgation ou perte du mot de passe de sécurité), sans recours contre bobtv.fr et ses auteurs et en garantissant d’ores et déjà bobtv.fr et ses auteurs à ce titre,</p>
            <p>- A assumer sans réserves toutes les conséquences de toutes natures à raison de déclarations en tout ou partie inexactes, sans recours contre bobtv.fr et ses auteurs.</p>
            <br/>
        </section>
    )
}


const ModalDisclaimerWithRouter = withRouter(ModalDisclaimer);
export default ModalDisclaimerWithRouter


// WEBPACK FOOTER //
// ./src/components/modals/ModalDisclaimer.js